import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["purchasePrice"]

  calculateDown() {
    // Placeholder for future auto-calculation of down payment
    // when purchase price changes
  }
}
